/**
 * Proveedores de pago disponibles
 */
export const PAYMENT_PROVIDERS = [
  { value: 'XNET', label: 'XNET' },
  { value: 'ICBC', label: 'ICBC' },
];

/**
 * Estados de procesamiento
 */
export const PROCESSING_STATES = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  VERIFYING: 'verifying',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  ERROR: 'error',
};

/**
 * Tipos de archivos permitidos
 */
export const ALLOWED_FILE_TYPES = ['.txt'];

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    FILE_UPLOADED: 'Archivo cargado exitosamente',
    VERIFICATION_COMPLETE: 'Verificación completada',
    PAYMENT_PROCESSED: 'Pago procesado exitosamente',
  },
  ERROR: {
    NO_FILE_SELECTED: 'Es necesario seleccionar un archivo',
    VERIFICATION_FAILED: 'Hubo un error al verificar el archivo. Por favor, intenta nuevamente.',
    PROCESSING_FAILED: 'Hubo un error al procesar el pago. Por favor, intenta nuevamente.',
    INVALID_FILE_TYPE: 'Tipo de archivo no válido. Solo se permiten archivos .txt',
    MISSING_USER_DATA: 'Error: Datos de usuario incompletos',
  },
  INFO: {
    NO_FILE_SELECTED: 'Sin archivos seleccionados',
    PROCESSING: 'Procesando...',
  },
};

/**
 * Configuración de estilos para el diálogo de cupones
 */
export const DIALOG_STYLES = {
  HEADER_CELL: {
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    textAlign: 'center',
    padding: '8px',
  },
  GREY_CELL: {
    backgroundColor: '#f2f2f2',
    border: '1px solid #a6a4a4',
    padding: '5px',
  },
  SECTION: {
    marginBottom: '16px',
  },
};

/**
 * Configuración de validación
 */
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['entidadRecaudadora', 'puntoDeVenta', 'fechaFactura'],
  FILE_SIZE_LIMIT: 10 * 1024 * 1024, // 10MB
};
